export const movies = [
  {
    id: "shenyuan-jiuyuan",
    title: "深渊救援",
    enTitle: "Abyss Rescue",
    tagline: "八百米深海，一次不能失败的营救",
    year: 2026,
    genres: ["动作", "冒险"],
    region: "国产",
    duration: 132,
    rating: 8.7,
    director: "林川",
    cast: ["沈亦舟", "顾夏", "韩牧", "周予安"],
    synopsis:
      "一支深海工程队在八百米海底作业时遭遇地层坍塌，氧气仅剩六小时。退役潜水员陆沉被迫重返深海，在完全失联的黑暗水域中寻找队友，也找回了自己当年放弃这份职业的原因。",
    views: 18640000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20deep%20sea%20diver%20in%20a%20heavy%20diving%20suit%20surrounded%20by%20dark%20underwater%20cave%20walls%20and%20a%20single%20beam%20of%20light%20from%20a%20rescue%20floodlight%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20deep%20ocean%20underwater%20trench%20with%20a%20tiny%20diving%20light%20beam%20cutting%20through%20dark%20blue%20water%20and%20floating%20particles%2C%20dramatic%20volumetric%20light%2C%20moody%20deep%20navy%20tones%20with%20amber%20highlights%2C%20atmospheric%20haze%2C%20cinematic%20anamorphic%20look%2C%20no%20text&width=1600&height=900&seq=hero-01&orientation=landscape",
    featured: true,
  },
  {
    id: "xinghuan-jiyuan",
    title: "星环纪元",
    enTitle: "Ring Era",
    tagline: "人类最后一次仰望，是星环升起的那一刻",
    year: 2026,
    genres: ["科幻", "冒险"],
    region: "欧美",
    duration: 148,
    rating: 9.1,
    director: "Ethan Cole",
    cast: ["Ava Reyes", "Noah Blake", "Liam Ford", "Mia Hart"],
    synopsis:
      "土星轨道上的科研站突然失联，一支四人小队前往调查，却发现星环内部藏着一座被遗忘了三百年的城市。当返航指令与真相冲突，他们必须在回家与公开真相之间做出选择。",
    views: 27310000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20an%20astronaut%20standing%20on%20a%20metal%20platform%20facing%20an%20enormous%20glowing%20ringed%20planet%20that%20fills%20the%20sky%2C%20star%20field%20background%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20space%20film%20still%20of%20a%20small%20research%20station%20floating%20near%20a%20giant%20ringed%20planet%20with%20icy%20particles%20and%20a%20distant%20blue%20sun%2C%20epic%20scale%2C%20volumetric%20light%20rays%2C%20deep%20cyan%20and%20amber%20color%20grading%2C%20subtle%20film%20grain%2C%20no%20text&width=1600&height=900&seq=hero-02&orientation=landscape",
    featured: true,
  },
  {
    id: "wucheng-yiyun",
    title: "雾城疑云",
    enTitle: "Fog City",
    tagline: "所有线索都指向同一个雾夜",
    year: 2025,
    genres: ["悬疑", "犯罪"],
    region: "国产",
    duration: 118,
    rating: 8.9,
    director: "陈牧野",
    cast: ["秦书言", "罗尘", "许清和", "白岩"],
    synopsis:
      "连续七年在同一个雾夜失踪的报案人，让刑警队重启了一桩旧案。随着档案被一页页翻开，负责此案的老刑警发现，自己才是那份卷宗里最后一个未被核对的名字。",
    views: 15980000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20detective%20in%20a%20long%20coat%20standing%20in%20a%20foggy%20old%20Chinese%20town%20street%20lit%20by%20a%20single%20streetlamp%2C%20back%20to%20camera%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-03&orientation=portrait",
    featured: true,
  },
  {
    id: "yinhe-xinshi",
    title: "银河信使",
    enTitle: "The Messenger",
    tagline: "一封来自四十年前的信，改变了整颗星球",
    year: 2026,
    genres: ["科幻", "剧情"],
    region: "欧美",
    duration: 141,
    rating: 8.8,
    director: "Sofia Lind",
    cast: ["Owen Park", "Clara Wood", "Ben Ortiz", "Ivy Chen"],
    synopsis:
      "在荒芜的沙漠星球上，一名信号维护员偶然接收到一段四十年前发出的求救广播。为了回应这段早已过期的呼救，他开始独自修理一座被所有人放弃的星际中继塔。",
    views: 13420000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lonely%20traveler%20in%20a%20weathered%20coat%20walking%20across%20an%20orange%20desert%20planet%20toward%20a%20glowing%20radio%20tower%2C%20huge%20empty%20sky%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-04&orientation=portrait",
  },
  {
    id: "zhuifengzhe",
    title: "追风者",
    enTitle: "Chasing Wind",
    tagline: "速度没有尽头，只有下一个弯道",
    year: 2025,
    genres: ["动作", "犯罪"],
    region: "国产",
    duration: 126,
    rating: 8.4,
    director: "郭野",
    cast: ["宋亦寒", "梁睿", "温小川"],
    synopsis:
      "曾是地下赛车冠军的修车工，为了替弟弟还清债务重回赛道。他很快发现，这场看似普通的夜间竞速，背后是一条横跨三座城市的走私链。",
    views: 11260000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20street%20racer%20in%20a%20leather%20jacket%20leaning%20on%20a%20black%20motorcycle%20in%20heavy%20night%20rain%2C%20wet%20asphalt%20reflecting%20amber%20city%20lights%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-05&orientation=portrait",
  },
  {
    id: "disan-fengxin",
    title: "第三封信",
    enTitle: "The Third Letter",
    tagline: "有些告别，要等十一年才寄到",
    year: 2024,
    genres: ["爱情", "剧情"],
    region: "日韩",
    duration: 112,
    rating: 8.2,
    director: "高木遥",
    cast: ["森川铃", "佐藤凉太", "田中美绪"],
    synopsis:
      "海边小城的邮局里，一名分拣员发现了一封没有地址、只写着「等我回来」的旧信。她开始按邮戳时间寻找收信人，也慢慢拼出自己母亲年轻时的那段感情。",
    views: 8640000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20young%20woman%20holding%20an%20old%20paper%20letter%20beside%20a%20rain%20streaked%20window%20with%20soft%20seaside%20light%2C%20gentle%20melancholy%20mood%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-06&orientation=portrait",
  },
  {
    id: "jiye-lieren",
    title: "极夜猎人",
    enTitle: "Polar Night",
    tagline: "在太阳不再升起的第三十天",
    year: 2026,
    genres: ["动作", "悬疑"],
    region: "欧美",
    duration: 135,
    rating: 8.6,
    director: "Marek Novak",
    cast: ["Ella Frost", "Jonas Berg", "Ruth Vale"],
    synopsis:
      "北极圈内的科考站进入极夜后，一名猎人在冰原上发现了一串不属于任何队员的脚印。随着补给车队失联，站内六个人开始互相怀疑，而真正的猎手一直藏在供暖管道里。",
    views: 12180000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20hooded%20arctic%20hunter%20holding%20a%20rifle%20in%20a%20blizzard%20at%20night%2C%20frozen%20wasteland%20and%20faint%20green%20aurora%20above%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20arctic%20film%20still%20of%20a%20lone%20snowmobile%20trail%20leading%20to%20a%20small%20research%20station%20under%20green%20aurora%20and%20endless%20polar%20night%2C%20deep%20navy%20blue%20with%20amber%20window%20lights%2C%20volumetric%20fog%2C%20no%20text&width=1600&height=900&seq=hero-03&orientation=landscape",
    featured: true,
  },
  {
    id: "yunduan-xiaozhen",
    title: "云端小镇",
    enTitle: "Town Above Clouds",
    tagline: "把思念寄放在云上，就不会下雨了",
    year: 2025,
    genres: ["动画", "奇幻"],
    region: "国产",
    duration: 98,
    rating: 9.0,
    director: "许知白",
    cast: ["季云舒", "陆星野", "阿岚"],
    synopsis:
      "一间开在云层之上的老邮局，专门替人保管没能寄出的心愿。新来的小邮差阿禾接下第一单生意，却要把一封写了十年的信，送到早已搬离小镇的女孩手里。",
    views: 14750000,
    poster:
      "https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20of%20a%20tiny%20floating%20village%20built%20on%20clouds%20with%20warm%20lantern%20lights%20and%20a%20small%20post%20office%2C%20a%20child%20looking%20up%20at%20the%20sky%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-08&orientation=portrait",
  },
  {
    id: "changye-jiangjin",
    title: "长夜将尽",
    enTitle: "Before the Dawn",
    tagline: "值完这一班，我就回家",
    year: 2024,
    genres: ["剧情", "悬疑"],
    region: "国产",
    duration: 127,
    rating: 8.5,
    director: "白启明",
    cast: ["何政", "苏晚", "李砚"],
    synopsis:
      "县医院夜班医生在最后一小时里接连遇到三个奇怪的病人，他们的叙述指向同一场十年前的医疗事故。当晨光透进走廊，他必须决定是交出一份真实的记录，还是继续沉默。",
    views: 7320000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20weary%20doctor%20standing%20in%20a%20dim%20hospital%20corridor%20at%20night%2C%20green%20fluorescent%20light%20mixed%20with%20warm%20amber%20lamp%2C%20long%20empty%20hallway%2C%20cinematic%20dramatic%20lighting%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-09&orientation=portrait",
  },
  {
    id: "nihong-shenyuan",
    title: "霓虹深渊",
    enTitle: "Neon Abyss",
    tagline: "记忆可以买卖，真相不能",
    year: 2026,
    genres: ["科幻", "犯罪"],
    region: "日韩",
    duration: 129,
    rating: 8.3,
    director: "郑在勋",
    cast: ["崔允书", "姜河", "李瑞妍", "朴度贤"],
    synopsis:
      "在可以租借他人记忆的未来城市，一名记忆修复师接到匿名委托：修复一段被人为抹去的凶案片段。越往深处追溯，他越确定自己也曾出现在那段记忆里。",
    views: 9930000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20hooded%20figure%20standing%20in%20a%20narrow%20neon%20lit%20cyberpunk%20alley%20with%20reflective%20wet%20ground%20and%20glowing%20signs%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-10&orientation=portrait",
  },
  {
    id: "wusheng-zhengyan",
    title: "无声证词",
    enTitle: "Silent Witness",
    tagline: "她什么都没说，却让所有人闭嘴",
    year: 2025,
    genres: ["悬疑", "剧情"],
    region: "国产",
    duration: 121,
    rating: 8.1,
    director: "沈京",
    cast: ["叶知秋", "陆行舟", "程曦"],
    synopsis:
      "一桩没有目击者的旧案重新开庭，唯一的关键证人是一名失语十年的女工。年轻律师靠着纸笔和她对话，逐渐发现当年所有人都听错了一个词，而那个词足以推翻整份判决。",
    views: 6180000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20young%20woman%20in%20a%20grey%20coat%20sitting%20in%20an%20empty%20courtroom%20holding%20a%20notebook%2C%20soft%20window%20light%20and%20long%20shadows%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-11&orientation=portrait",
  },
  {
    id: "shanhai-yiwen",
    title: "山海异闻",
    enTitle: "Tales of Mountains",
    tagline: "古卷翻开，山海重临",
    year: 2026,
    genres: ["奇幻", "冒险"],
    region: "国产",
    duration: 144,
    rating: 8.7,
    director: "岑野",
    cast: ["江牧", "苏叶", "北海", "青禾"],
    synopsis:
      "一本残缺的山海图志在博物馆失窃，守卷人之后与一名古籍修复师被迫同行。他们沿着图上的墨迹穿越六重幻境，才发现真正需要被封印的，是人心里的那只兽。",
    views: 17820000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20mythical%20eastern%20mountain%20landscape%20with%20a%20giant%20shadowy%20beast%20silhouette%20among%20ink%20wash%20peaks%20and%20a%20lone%20traveler%20with%20a%20lantern%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20fantasy%20film%20still%20of%20floating%20eastern%20mountains%20above%20a%20sea%20of%20clouds%20with%20ancient%20stone%20gates%20and%20glowing%20lanterns%2C%20ink%20wash%20textures%2C%20deep%20navy%20and%20amber%20grading%2C%20drifting%20mist%2C%20no%20text&width=1600&height=900&seq=hero-04&orientation=landscape",
    featured: true,
  },
  {
    id: "niguang-feixing",
    title: "逆光飞行",
    enTitle: "Against the Light",
    tagline: "跑道尽头，是十八岁那年的天空",
    year: 2024,
    genres: ["剧情", "爱情"],
    region: "国产",
    duration: 116,
    rating: 7.9,
    director: "温言",
    cast: ["夏一鸣", "顾清", "陈屿"],
    synopsis:
      "小城滑翔机俱乐部的两个年轻人约定一起飞出山谷，却因为一场事故各自停在原地十年。当旧机场即将被改建，他们重新站上跑道，试着把没说完的那句话说完。",
    views: 5410000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20young%20pilot%20standing%20beside%20a%20vintage%20glider%20on%20a%20grassy%20airstrip%20at%20golden%20sunset%2C%20warm%20backlight%20and%20long%20shadows%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-13&orientation=portrait",
  },
  {
    id: "wuye-diantai",
    title: "午夜电台",
    enTitle: "Midnight Radio",
    tagline: "凌晨三点，请不要接听陌生来电",
    year: 2025,
    genres: ["恐怖", "悬疑"],
    region: "日韩",
    duration: 104,
    rating: 7.6,
    director: "小野寺",
    cast: ["水野遥", "大岛修", "南怜"],
    synopsis:
      "深夜电台主播收到一段来自空频道的求救录音，录音里的声音和她的听众一模一样。随着直播间里的时钟开始倒转，她意识到自己正在播报一场已经发生过的事故。",
    views: 4720000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20horror%20movie%20poster%20of%20an%20empty%20radio%20studio%20at%20midnight%20with%20a%20single%20red%20on%20air%20light%20and%20a%20headset%20on%20the%20desk%2C%20eerie%20shadows%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-14&orientation=portrait",
  },
  {
    id: "gangtie-liming",
    title: "钢铁黎明",
    enTitle: "Steel Dawn",
    tagline: "当城市沉没，钢铁替人类站起",
    year: 2026,
    genres: ["动作", "科幻"],
    region: "欧美",
    duration: 152,
    rating: 8.9,
    director: "Marcus Hale",
    cast: ["Dylan Cross", "Nina Vale", "Ronan Price", "Zoe Adler"],
    synopsis:
      "废弃工业城在黎明前遭遇未知机械潮，一名维修技师启动了仓库里封存已久的原型机。他很快发现，这台钢铁巨兽的核心记忆里，存着他失踪父亲最后一段影像。",
    views: 21450000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20massive%20battle%20worn%20steel%20mech%20standing%20in%20a%20ruined%20city%20at%20dawn%20with%20amber%20sun%20breaking%20through%20smoke%2C%20tiny%20human%20silhouette%20in%20foreground%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20sci%20fi%20film%20still%20of%20a%20colossal%20mech%20silhouette%20against%20a%20burning%20city%20skyline%20at%20dawn%2C%20thick%20smoke%20and%20orange%20sunlight%20rays%2C%20deep%20navy%20shadows%2C%20epic%20scale%2C%20no%20text&width=1600&height=900&seq=hero-05&orientation=landscape",
    featured: true,
  },
  {
    id: "xiaochouyu-huijia",
    title: "小丑鱼回家记",
    enTitle: "Finding Home",
    tagline: "整片海，都不如回家那条路",
    year: 2024,
    genres: ["动画", "冒险"],
    region: "欧美",
    duration: 92,
    rating: 8.4,
    director: "Ruby Lane",
    cast: ["Toby Miles", "Anna Reed", "Sam Cole"],
    synopsis:
      "一场洋流风暴把幼年小丑鱼卷到了陌生海域，它必须跟着一只话很多的寄居蟹穿过珊瑚城、沉船湾与暗流带，才能回到那片熟悉的海葵旁。",
    views: 10650000,
    poster:
      "https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20of%20a%20tiny%20orange%20clownfish%20swimming%20through%20a%20vibrant%20coral%20reef%20with%20sunbeams%20from%20above%20and%20a%20friendly%20hermit%20crab%20beside%20it%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-16&orientation=portrait",
  },
  {
    id: "dongri-lieche",
    title: "冬日列车",
    enTitle: "Winter Train",
    tagline: "雪停之前，我们还有一站",
    year: 2025,
    genres: ["爱情", "剧情"],
    region: "日韩",
    duration: 108,
    rating: 8.0,
    director: "青木原",
    cast: ["新垣遥", "松本凉", "石井千夏"],
    synopsis:
      "暴雪导致列车滞留在一个无名小站，两个多年未见的旧同学被安排在同一节车厢。一整夜的对白里，他们重新走过了当年谁也没敢先开口的那个冬天。",
    views: 6840000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20snowy%20train%20platform%20at%20dusk%20with%20two%20figures%20in%20winter%20coats%20standing%20apart%2C%20warm%20station%20lamp%20glow%20against%20cold%20blue%20snow%2C%20cinematic%20dramatic%20lighting%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-17&orientation=portrait",
  },
  {
    id: "zuihou-shouyeren",
    title: "最后的守夜人",
    enTitle: "The Last Warden",
    tagline: "门后是什么，他守了三百年",
    year: 2026,
    genres: ["奇幻", "动作"],
    region: "欧美",
    duration: 139,
    rating: 8.5,
    director: "Ivan Petrov",
    cast: ["Leo Marsh", "Ada Quinn", "Victor Hale"],
    synopsis:
      "边境古堡的最后一位守夜人接到命令：今夜之后，封印将永久解除。他必须在黎明前做出选择——把钥匙交给赶来的继承人，还是自己走进那扇从不该被打开的门。",
    views: 12890000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20movie%20poster%20of%20a%20cloaked%20warden%20holding%20a%20glowing%20lantern%20before%20a%20giant%20ancient%20stone%20gate%20at%20night%2C%20mist%20and%20faint%20runic%20light%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-18&orientation=portrait",
  },
  {
    id: "baoxue-xingdong",
    title: "暴雪行动",
    enTitle: "Operation Blizzard",
    tagline: "六小时，一座山，一条命",
    year: 2024,
    genres: ["战争", "动作"],
    region: "欧美",
    duration: 146,
    rating: 8.2,
    director: "Karl Weiss",
    cast: ["Anton Reid", "Sara Novak", "Emil Kraft"],
    synopsis:
      "极寒山区的一支通讯小队必须在六小时内修复被切断的线路，否则整条防线将失去联络。风雪、雷区与追击同时逼近，他们要保住的不只是设备，还有一个不能公开的坐标。",
    views: 9130000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20war%20movie%20poster%20of%20three%20soldiers%20in%20snow%20camouflage%20advancing%20through%20a%20blizzard%20with%20rifles%2C%20frozen%20pine%20forest%20and%20white%20out%20light%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-19&orientation=portrait",
  },
  {
    id: "zhi-yueliang",
    title: "纸月亮",
    enTitle: "Paper Moon",
    tagline: "小镇的夜里，月亮是纸做的",
    year: 2025,
    genres: ["剧情"],
    region: "国产",
    duration: 114,
    rating: 7.8,
    director: "钟离",
    cast: ["宁枝", "周冕", "阿吉"],
    synopsis:
      "为了给即将关闭的露天电影院办最后一场放映，放映员的女儿用纸糊了一轮月亮挂上屋顶。那一夜，整个小镇的人都来了，包括她十年没回家的父亲。",
    views: 3980000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20young%20girl%20standing%20on%20a%20small%20town%20rooftop%20holding%20a%20large%20glowing%20paper%20moon%20lantern%2C%20distant%20old%20cinema%20lights%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20haze%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-20&orientation=portrait",
  },
  {
    id: "liehuzuo-jihua",
    title: "猎户座计划",
    enTitle: "Project Orion",
    tagline: "我们不是第一批到这里的人",
    year: 2026,
    genres: ["科幻", "悬疑"],
    region: "欧美",
    duration: 133,
    rating: 9.2,
    director: "Nolan Bryce",
    cast: ["Chloe Grant", "Adam Voss", "Tara Lin", "Miles Reed"],
    synopsis:
      "深空监测站接收到一段以人类语言播报的倒计时，起点是七十年前。随着倒计时归零，站内系统开始执行一份从未被写入程序的撤离方案，而名单上少了一个人。",
    views: 24880000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20movie%20poster%20of%20a%20lone%20engineer%20silhouette%20inside%20a%20dark%20orbital%20control%20room%20lit%20by%20holographic%20amber%20screens%2C%20earth%20visible%20through%20the%20window%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-21&orientation=portrait",
  },
  {
    id: "jiejiao-shitang",
    title: "街角食堂",
    enTitle: "Corner Diner",
    tagline: "凌晨的汤，一直是热的",
    year: 2025,
    genres: ["剧情", "喜剧"],
    region: "日韩",
    duration: 105,
    rating: 8.6,
    director: "坂本旬",
    cast: ["小林千鹤", "堀内健", "吉田步"],
    synopsis:
      "一家只开到凌晨四点的小食堂，每晚迎来不同的客人：加完班的程序员、失恋的出租车司机、偷偷练歌的高中生。老板从不多问，只把同一锅汤再热一次。",
    views: 11270000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20cozy%20tiny%20late%20night%20diner%20with%20warm%20lantern%20light%20spilling%20onto%20a%20wet%20street%2C%20steam%20rising%20from%20a%20pot%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-22&orientation=portrait",
  },
  {
    id: "fanzha-fengbao",
    title: "反诈风暴",
    enTitle: "Storm of Lies",
    tagline: "电话那头，从来不只一个人",
    year: 2026,
    genres: ["犯罪", "剧情"],
    region: "国产",
    duration: 124,
    rating: 8.3,
    director: "韩启",
    cast: ["程野", "罗小满", "邱明", "宋佳"],
    synopsis:
      "反诈中心接到一起跨省案件，受害人遍布七个城市，却都接到同一声「喂」。年轻警察从一段环境音里锁定了窝点位置，也把自己刚退休的师父推到了危险最前线。",
    views: 13680000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20movie%20poster%20of%20a%20detective%20standing%20before%20a%20wall%20of%20phones%20and%20red%20case%20files%20in%20a%20dark%20office%2C%20cold%20monitor%20glow%20mixed%20with%20amber%20lamp%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-23&orientation=portrait",
  },
  {
    id: "shuangzi-mian",
    title: "双子谜案",
    enTitle: "Gemini Case",
    tagline: "镜子里的人，先动了一下",
    year: 2024,
    genres: ["悬疑", "犯罪"],
    region: "欧美",
    duration: 117,
    rating: 8.8,
    director: "Grace Miller",
    cast: ["Ethan Shaw", "Lily Shaw", "Mark Dann"],
    synopsis:
      "一宗密室案里，唯一的目击者是一对双胞胎姐妹，她们的证词完全相反。心理医生在第七次会谈时发现，两个人的记忆正在悄悄交换，而凶手就坐在她们中间。",
    views: 10490000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20thriller%20movie%20poster%20of%20two%20identical%20twin%20women%20standing%20on%20opposite%20sides%20of%20a%20cracked%20mirror%20in%20a%20dim%20room%2C%20one%20lit%20warm%20one%20lit%20cold%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-24&orientation=portrait",
  },
  {
    id: "shamo-zhishi",
    title: "沙漠之诗",
    enTitle: "Poems of Sand",
    tagline: "走过这片沙，就听见自己",
    year: 2025,
    genres: ["冒险", "剧情"],
    region: "其他",
    duration: 131,
    rating: 8.1,
    director: "Amir Haddad",
    cast: ["Yara Nabil", "Karim Aziz", "Leila Farah"],
    synopsis:
      "一位失去声音的诗人和一位不识字的向导结伴穿越沙漠，去寻找传说中会复述人一生故事的古井。走到第三天，他们开始用脚印写诗。",
    views: 4560000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20solitary%20traveler%20in%20flowing%20robes%20walking%20across%20endless%20golden%20sand%20dunes%20at%20sunset%2C%20long%20shadow%20and%20wind%20blown%20sand%20haze%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-25&orientation=portrait",
  },
  {
    id: "shaonian-yujing",
    title: "少年与鲸",
    enTitle: "The Boy and the Whale",
    tagline: "它游过天空，只为送他回家",
    year: 2026,
    genres: ["动画", "奇幻"],
    region: "国产",
    duration: 96,
    rating: 8.9,
    director: "黎白",
    cast: ["小满", "阿澈", "云舟"],
    synopsis:
      "住在海边灯塔的少年，每晚都能看见一条鲸游过星空。当台风摧毁灯塔，他跟着鲸的影子走进云层，去寻找那座能让灯火重新亮起的老灯芯。",
    views: 15240000,
    poster:
      "https://readdy.ai/api/search-image?query=Animated%20movie%20poster%20of%20a%20small%20boy%20standing%20on%20a%20cliff%20reaching%20toward%20a%20giant%20gentle%20whale%20swimming%20through%20a%20starry%20night%20sky%20above%20the%20sea%2C%20glowing%20blue%20and%20amber%20tones%2C%20cinematic%20dramatic%20lighting%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-26&orientation=portrait",
  },
  {
    id: "shizhong-niandai",
    title: "失重年代",
    enTitle: "Weightless Years",
    tagline: "我们漂浮着，以为那就是自由",
    year: 2025,
    genres: ["剧情", "科幻"],
    region: "国产",
    duration: 120,
    rating: 8.0,
    director: "程一维",
    cast: ["方野", "何以", "林深"],
    synopsis:
      "第一批太空移民回到地球后，出现了无法适应重力的症状。一名康复师在照顾这些「失重病人」的过程中，逐渐理解了自己当年为什么选择留在地面。",
    views: 5320000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20an%20astronaut%20floating%20weightlessly%20inside%20a%20plain%20furnished%20earth%20apartment%20with%20sunlight%20through%20curtains%2C%20surreal%20calm%20mood%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-27&orientation=portrait",
  },
  {
    id: "anxiang-zhuixiong",
    title: "暗巷追凶",
    enTitle: "Alley Hunt",
    tagline: "转过这个巷口，就没有退路",
    year: 2024,
    genres: ["动作", "犯罪"],
    region: "日韩",
    duration: 113,
    rating: 7.7,
    director: "朴正勋",
    cast: ["李在赫", "申允", "金度完"],
    synopsis:
      "一名追捕逃犯的刑警被反锁在城市旧区的巷网里，手机没电、支援未到。他只能靠着地上的积水反光，判断那个熟悉的身影拐向了哪一条路。",
    views: 6210000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20poster%20of%20a%20policeman%20mid%20chase%20in%20a%20narrow%20night%20alley%20with%20wet%20cobblestones%20and%20hanging%20cables%2C%20distant%20amber%20sign%20light%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-28&orientation=portrait",
  },
  {
    id: "xingqiu-hunli",
    title: "星球婚礼",
    enTitle: "Planet Wedding",
    tagline: "在离地球最远的地方说我愿意",
    year: 2026,
    genres: ["爱情", "科幻"],
    region: "欧美",
    duration: 111,
    rating: 7.9,
    director: "Hana Brooks",
    cast: ["Nora Bell", "Eli Ward", "Pia Ross"],
    synopsis:
      "一对情侣报名参加首批星际婚礼计划，却因为一次轨道延误，被迫在空间站的货运舱里完成仪式。两个人的誓言，被全站十二名陌生人一起见证。",
    views: 4870000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20sci%20fi%20movie%20poster%20of%20a%20couple%20in%20simple%20white%20wedding%20clothes%20holding%20hands%20inside%20a%20space%20station%20observation%20deck%20with%20a%20vast%20planet%20outside%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-29&orientation=portrait",
  },
  {
    id: "tiexue-zhengcheng",
    title: "铁血征程",
    enTitle: "Iron March",
    tagline: "没有人记得他们的名字，但路记得",
    year: 2025,
    genres: ["战争", "剧情"],
    region: "国产",
    duration: 138,
    rating: 8.4,
    director: "冯岳",
    cast: ["段铮", "何川", "李长山", "邓宁"],
    synopsis:
      "一支后勤运输队在漫天黄沙中护送一批药品穿越封锁线。八天七夜，他们没有开过一枪，却用一条被反复修补的路线，改变了一场战役的结局。",
    views: 8370000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20war%20movie%20poster%20of%20a%20column%20of%20soldiers%20marching%20through%20yellow%20dust%20on%20a%20barren%20road%20with%20supply%20carts%2C%20harsh%20sunlight%20and%20dust%20haze%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-30&orientation=portrait",
  },
  {
    id: "jingzhong-migong",
    title: "镜中迷宫",
    enTitle: "Mirror Maze",
    tagline: "走出去的，未必是进来的那个",
    year: 2026,
    genres: ["悬疑", "奇幻"],
    region: "欧美",
    duration: 115,
    rating: 8.6,
    director: "Julian Frost",
    cast: ["Iris Cole", "Sam Doyle", "Rita Venn"],
    synopsis:
      "一座巡回展出的镜面迷宫在每个城市都会让一个人消失。建筑师受托重建迷宫结构，却在图纸上一次次画出同一间不存在的房间。",
    views: 9080000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20movie%20poster%20of%20a%20woman%20walking%20through%20an%20endless%20mirror%20maze%20with%20infinite%20reflections%20and%20a%20single%20amber%20light%20above%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-31&orientation=portrait",
  },
  {
    id: "xiaye-shiqi",
    title: "夏夜十七度",
    enTitle: "Seventeen Degrees",
    tagline: "那个夏天，风一直是十七度",
    year: 2024,
    genres: ["爱情", "剧情"],
    region: "国产",
    duration: 103,
    rating: 7.5,
    director: "顾南",
    cast: ["纪遥", "沈星", "唐棠"],
    synopsis:
      "海边的旧旅店只剩最后一个夏天营业，四个刚高考完的少年在这里打零工。空调坏掉的那几天，他们把所有没说出口的话都写在了留言簿上。",
    views: 3640000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20coming%20of%20age%20movie%20poster%20of%20teenagers%20sitting%20on%20a%20seaside%20rooftop%20at%20dusk%20with%20string%20lights%20and%20a%20breeze%2C%20nostalgic%20warm%20summer%20mood%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-32&orientation=portrait",
  },
  {
    id: "shenhai-jingmo",
    title: "深海静默",
    enTitle: "Silent Deep",
    tagline: "三千米之下，连回声都没有",
    year: 2026,
    genres: ["科幻", "冒险"],
    region: "欧美",
    duration: 142,
    rating: 8.8,
    director: "Peter Lang",
    cast: ["Maya Quinn", "Dean Foster", "Otto Reis"],
    synopsis:
      "深海探测艇在海沟底部失去声呐信号，五名船员只能依靠手写指令行动。当舷窗外出现规律排列的灯光时，他们明白自己并不是这片海域唯一的访客。",
    views: 16730000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20movie%20poster%20of%20a%20small%20deep%20sea%20submersible%20surrounded%20by%20complete%20blackness%20with%20strange%20rows%20of%20amber%20lights%20in%20the%20distance%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-33&orientation=portrait",
  },
  {
    id: "chengshi-zhiguang",
    title: "城市之光",
    enTitle: "City Lights",
    tagline: "每一盏亮着的窗，都有一个故事",
    year: 2025,
    genres: ["剧情", "犯罪"],
    region: "国产",
    duration: 126,
    rating: 8.2,
    director: "周予",
    cast: ["陈默", "许安", "郑一鸣"],
    synopsis:
      "一名夜班代驾在城市里穿梭，接送过形形色色的人。直到某个凌晨，他接到一个不该出现在订单里的地址，也第一次直面这座城市最不愿被看见的一面。",
    views: 7640000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20lone%20figure%20standing%20on%20an%20overpass%20overlooking%20a%20glowing%20city%20skyline%20at%20night%20with%20light%20trails%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-34&orientation=portrait",
  },
  {
    id: "youling-lieche",
    title: "幽灵列车",
    enTitle: "Ghost Train",
    tagline: "末班车之后，还有一班",
    year: 2024,
    genres: ["恐怖", "奇幻"],
    region: "日韩",
    duration: 101,
    rating: 7.4,
    director: "宫下彻",
    cast: ["桥本奈", "小林悠", "高梨真"],
    synopsis:
      "地铁员工发现每天凌晨两点十七分会有一列不在时刻表上的列车进站。为了找回误上车的妹妹，他刷卡进站，成为那趟车上的第九名乘客。",
    views: 4180000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20horror%20movie%20poster%20of%20an%20old%20empty%20subway%20train%20arriving%20at%20a%20fog%20filled%20platform%20at%20night%20with%20flickering%20amber%20lights%2C%20eerie%20atmosphere%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-35&orientation=portrait",
  },
  {
    id: "fengqi-changan",
    title: "风起长安",
    enTitle: "Wind Over Chang'an",
    tagline: "一城灯火，半世风沙",
    year: 2026,
    genres: ["剧情", "冒险"],
    region: "国产",
    duration: 150,
    rating: 9.0,
    director: "柳长风",
    cast: ["谢临", "姜绾", "裴渡", "阿史那"],
    synopsis:
      "长安城最年轻的城门令，在一次风沙夜放走了一支没有通关文书的商队。十年后，那支商队带着足以改变整座城的消息回来了，而他必须再一次决定开不开门。",
    views: 23160000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20epic%20historical%20movie%20poster%20of%20a%20sword%20carrying%20figure%20in%20flowing%20dark%20robes%20standing%20before%20ancient%20Chinese%20city%20walls%20at%20dusk%20with%20countless%20lanterns%20and%20drifting%20sand%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-36&orientation=portrait",
  },
  {
    id: "yueye-mitu",
    title: "越野迷途",
    enTitle: "Lost Off-road",
    tagline: "地图之外，还有六百公里",
    year: 2025,
    genres: ["冒险", "动作"],
    region: "其他",
    duration: 119,
    rating: 7.8,
    director: "Diego Salas",
    cast: ["Mateo Ruiz", "Ana Vega", "Luis Prado"],
    synopsis:
      "三名越野爱好者在峡谷深处偏离路线，车辆陷进干涸河床。为了在天黑前找到公路，他们必须徒步穿过一片没有任何手机信号的红色岩区。",
    views: 5120000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20adventure%20movie%20poster%20of%20a%20dusty%20off%20road%20suv%20parked%20in%20a%20red%20rock%20canyon%20at%20late%20afternoon%20with%20three%20figures%20looking%20at%20a%20map%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-37&orientation=portrait",
  },
  {
    id: "wusheng-zhijing",
    title: "无声之境",
    enTitle: "Realm of Silence",
    tagline: "听不见的世界，反而更清楚",
    year: 2026,
    genres: ["剧情", "悬疑"],
    region: "日韩",
    duration: 108,
    rating: 8.3,
    director: "井上怜",
    cast: ["石原奏", "松冈凛", "藤井和"],
    synopsis:
      "失聪的森林巡护员在例行巡查时发现一处被刻意掩盖的采伐点。没有声音可以依靠，她只能凭地面的震动与鸟群的异常，一点点拼出真相。",
    views: 5930000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20of%20a%20young%20woman%20with%20a%20walking%20stick%20standing%20in%20a%20misty%20pine%20forest%20listening%20with%20her%20hand%20raised%2C%20soft%20amber%20light%20through%20trees%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-38&orientation=portrait",
  },
  {
    id: "xingji-shihuangzhe",
    title: "星际拾荒者",
    enTitle: "Orbital Scavenger",
    tagline: "别人不要的，正好是我要的",
    year: 2025,
    genres: ["科幻", "动作"],
    region: "欧美",
    duration: 130,
    rating: 8.5,
    director: "Rex Dalton",
    cast: ["Finn Hayes", "Zara Moss", "Cole Bishop"],
    synopsis:
      "靠拆解废弃飞船为生的拾荒者在残骸里发现了一枚仍在运行的航行日志。为了把它送到唯一会相信的人手里，他得先躲过三支同样在找它的舰队。",
    views: 14370000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20movie%20poster%20of%20a%20scavenger%20in%20a%20patched%20spacesuit%20standing%20on%20the%20hull%20of%20a%20wrecked%20starship%20with%20debris%20field%20and%20distant%20sun%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-39&orientation=portrait",
  },
  {
    id: "nuandong-kafeiguan",
    title: "暖冬咖啡馆",
    enTitle: "Warm Winter Cafe",
    tagline: "一杯热咖啡，等一个迟到的人",
    year: 2024,
    genres: ["爱情", "喜剧"],
    region: "国产",
    duration: 99,
    rating: 7.9,
    director: "苏木",
    cast: ["林暖", "顾言", "小鹿"],
    synopsis:
      "街角咖啡馆的老板有个奇怪的习惯：每天多做一杯拿铁，放在靠窗的位置。新来的兼职生想弄清那杯咖啡是留给谁的，却意外把店里的常客都变成了故事的主角。",
    views: 6940000,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20comedy%20movie%20poster%20of%20a%20cozy%20corner%20cafe%20in%20winter%20with%20snow%20outside%20the%20window%2C%20a%20latte%20on%20the%20windowside%20table%20and%20warm%20amber%20lights%2C%20cinematic%20dramatic%20lighting%2C%20deep%20navy%20color%20grading%2C%20premium%20film%20key%20art%2C%20vertical%20composition%2C%20no%20text&width=600&height=900&seq=poster-40&orientation=portrait",
  },
];